export const negativePrefix = "non-";
export const worldWide = "XX";
